import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { VatTypeEnum } from "src/enums/VatTypeEnum";
import { AmountHelper } from "src/helpers/AmountHelper";

const CommodityWaybillsDetailProducts = () => {
  const tableName = "commodityWaybillProducts";
  const { setValue, getValues } = useFormContext();
  const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
    setValue(`${tableName}.${index}.vatAmount`, AmountHelper.getVatAmount(newVatType, getValues(`${tableName}.${index}.amount`), getValues("priceIncludesVat")));
  };
  const { t } = useTranslation();
  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );

    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  return (
    <NFormTable fieldArray={"commodityWaybillProducts"}>
      <NFLookupBaseDocuments title={t("parentDocumentId")} fieldName="parentDocumentId" />
      <NFTextInput fieldName={"signNotice"} title={t("signNotice")} />
      <NFTextInput fieldName={"forGoodsCode"} title={t("ForGoodsCode")} />
      <NFTextInput fieldName={"productName"} title={t("ProductName")} />
      <NFIntInput fieldName={"quantity"} title={t("Quantity")} width={100} onValueChanged={handleQuantityChanged} />
      <NFIntInput fieldName={"unitPrice"} title={t("UnitPrice")} width={100} onValueChanged={handleQuantityChanged} />
      <NFIntInput fieldName={"forGoodsPrice"} title={t("ForGoodsPrice")} width={100} onValueChanged={handleQuantityChanged} />
      <NFIntInput fieldName={"tax"} title={t("Tax")} width={100} />
      <NFIntInput fieldName={"additionalQuantity"} title={t("additionalQuantity")} width={100} />
      <NFTextInput fieldName={"furnishingRecognitionNo"} title={t("furnishingRecognitionNo")} />
      <NFIntInput fieldName={"price"} title={t("Price")} width={100} onValueChanged={handlePriceChanged} />
      <NFIntInput fieldName={"amount"} title={t("Amount")} width={100} />
    </NFormTable>
  );
};

export default CommodityWaybillsDetailProducts;
